import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { holidayForShift } from "@/components/team/Holidays/schedule/scheduleHolidays";
import { usePageScheduleHolidays } from "@/components/team/Holidays/schedule/scheduleHolidaysContext";
import { useAnalytics } from "@/contexts/analytics/hooks";
import { useHospitalData } from "@/contexts/HospitalDataProvider";
import { useScheduleDayOf } from "@/hooks/useScheduleDayOf";
import type { NurseInShift } from "@/utils/models";
import { toIsoDate } from "@/utils/scheduleWeeks";
import { MobileNurseItem } from "./MobileNurseItem";

type MobileNursesListProps = {
	nurses: NurseInShift[];
};

export const MobileNursesList: FC<MobileNursesListProps> = ({ nurses }) => {
	const navigate = useNavigate();
	const { chosenDepartment } = useHospitalData();
	const { track } = useAnalytics();
	const scheduleDayOf = useScheduleDayOf();
	const { holidays } = usePageScheduleHolidays();

	const onClick = useCallback(
		(shift: NurseInShift) => {
			track("nurse_shift_details_mobile", { nurse_in_shift_id: shift.id });
			// The page finds the shift in its day's weeks.
			navigate(`/${chosenDepartment.department_id}/shift/${shift.id}?date=${toIsoDate(scheduleDayOf(shift).date)}`);
		},
		[navigate, track, chosenDepartment, scheduleDayOf],
	);

	return (
		<>
			{nurses.map((nurse: NurseInShift) => (
				<MobileNurseItem key={nurse.id} nurse={nurse} onClick={() => onClick(nurse)} shiftHoliday={holidayForShift(nurse, holidays)} />
			))}
		</>
	);
};
